// Money & date formatting — Turkish locale, tabular numbers.
// Currency symbol mapping — TRY → ₺, USD → $, EUR → €, GBP → £, CHF → CHF
const CURRENCY_SYMBOLS = {
  TRY: "₺", TL: "₺",
  USD: "$", EUR: "€", GBP: "£", CHF: "CHF",
};

export const fmtMoney = (v, currency = "TRY") => {
  if (v === null || v === undefined || v === "") return "—";
  const num = typeof v === "string" ? parseFloat(v) : v;
  if (Number.isNaN(num)) return String(v);
  const number = new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num);
  if (!currency) return number;
  const symbol = CURRENCY_SYMBOLS[currency.toUpperCase()] || currency;
  return `${number} ${symbol}`;
};

export const fmtNumber = (v, digits = 2) => {
  if (v === null || v === undefined) return "—";
  const num = typeof v === "string" ? parseFloat(v) : v;
  if (Number.isNaN(num)) return String(v);
  return new Intl.NumberFormat("tr-TR", {
    minimumFractionDigits: digits, maximumFractionDigits: digits,
  }).format(num);
};

export const fmtDate = (v) => {
  if (!v) return "—";
  try {
    const d = typeof v === "string" ? new Date(v) : v;
    return new Intl.DateTimeFormat("tr-TR",
      { year: "numeric", month: "2-digit", day: "2-digit" }).format(d);
  } catch { return String(v); }
};

export const fmtDateTime = (v) => {
  if (!v) return "—";
  try {
    const d = typeof v === "string" ? new Date(v) : v;
    return new Intl.DateTimeFormat("tr-TR", {
      year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit",
    }).format(d);
  } catch { return String(v); }
};

export const isoDate = (d = new Date()) => d.toISOString().split("T")[0];
